<div class="dalle-dialog" role="dialog" aria-modal="true" aria-labelledby="dalle-title">
  <header class="dialog-header">
    <div class="title-wrap">

      <h2 id="dalle-title">DAL·E </h2>
      <div class="chips">
  
        <span class="chip chip-type">Generative Art • Photoreal • Branding Concepts</span>
      </div>
    </div>

    <button class="close-btn" type="button" aria-label="Close dialog" (click)="close()">
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </header>
  <section class="examples">
    <h4>Example prompts</h4>
    <div class="code-grid">
      <pre class="code"><code>“Hero product shot of a stainless-steel smartwatch on a marble slab, 85 mm lens, soft rim lighting, bokeh background, realistic reflections, no watermark”</code></pre>
      <pre class="code"><code>“Minimalist logo concept for a boutique coffee brand named ‘Harbor’, geometric mark + wordmark, warm palette, vector-friendly shapes, no text effects”</code></pre>
      <pre class="code"><code>“Editorial photo of a runner at dawn on a foggy bridge, cinematic color grade, motion blur, shallow depth of field, natural skin, no logo”</code></pre>
    </div>
  </section>
  <section class="hero">
    <div class="hero-card">
      <div class="hero-copy">
        <h3>Why choose DAL·E?</h3>
        <p>
          <strong>DAL·E</strong> is your versatile image generator for concepting, photoreal scenes,
          brand exploration, and campaign-ready visuals. It’s excellent at <em>style control</em>,
          <em>composition</em>, and <em>art direction</em> while keeping iteration fast.
        </p>
        <ul class="highlights">
          <li>
            <span class="icon" aria-hidden="true">🎨</span>
            Strong stylization & art-direction control (lighting, lenses, palettes)
          </li>
          <li>
            <span class="icon" aria-hidden="true">🧭</span>
            Cohesive composition with clear subject focus
          </li>
          <li>
            <span class="icon" aria-hidden="true">🔁</span>
            Iterative flow support (edit/variations over a previous response)
          </li>
          <li>
            <span class="icon" aria-hidden="true">🧱</span>
            Great for logos/marks exploration, product mockups, social creatives
          </li>
        </ul>
      </div>

      <div class="hero-side">
        <div class="stat">
          <div class="stat-value">1024²</div>
          <div class="stat-label">Square</div>
        </div>
        <div class="stat">
          <div class="stat-value">1536×1024</div>
          <div class="stat-label">Landscape</div>
        </div>
        <div class="stat">
          <div class="stat-value">1024×1536</div>
          <div class="stat-label">Portrait</div>
        </div>
      </div>
    </div>
  </section>

  <section class="grid">
    <article class="card">
      <h4>Best for</h4>
      <ul class="bullets">
        <li>Brand & logo explorations (early ideation)</li>
        <li>Ad/social campaign concept art</li>
        <li>Product mockups & packaging</li>
        <li>Illustrations and stylized artwork</li>
        <li>Editorial and photoreal scenes</li>
      </ul>
    </article>

    <article class="card">
      <h4>When to pick DAL·E</h4>
      <p class="muted">
        Choose <strong>DAL·E</strong> when you need rich style control, clean compositions, and quick
        iterations—especially for visual identity work, concept boards, or polished hero shots.
      </p>
      <ul class="checks">
        <li>Need multiple layout/ratio options</li>
        <li>Precise lighting & camera direction</li>
        <li>Creative brand/world-building tasks</li>
      </ul>
    </article>

    <article class="card">
      <h4>Tips for great results</h4>
      <ol class="tips">
        <li><strong>Specify</strong> subject, materials, lens, lighting, mood, palette.</li>
        <li><strong>Composition</strong>: angle, framing, depth of field, negative space.</li>
        <li><strong>Style cues</strong>: “studio softbox”, “cinematic 35 mm”, “isometric render”.</li>
        <li><strong>Negatives</strong>: add “no watermark, no text” when needed.</li>
      </ol>
    </article>

    <article class="card">
      <h4>Suggested settings (Clarichat)</h4>
      <div class="kv">
        <div><span>Model key</span><code>{{ modelId }}</code></div>
        <div><span>size</span><code>1024×1024 • 1024×1536 • 1536×1024</code></div>
        <div><span>quality</span><code>standard • high</code></div>
        <div><span>background</span><code>auto • transparent • opaque</code></div>
      </div>
      <div class="cta-row">
        <button class="btn primary" type="button" (click)="useModel()">Use this model</button>
        <button class="btn ghost" type="button" (click)="close()">Close</button>
      </div>
    </article>
  </section>




</div>
